export default __webpack_public_path__ + "static/media/svnit.4990a777.png";